module.exports = __webpack_public_path__ + "static/media/logo-white.1245bd0c.png";